import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IcoStar, Select } from '../../../components'
import './swot.scss'
import Filter from './filter/filter'
import { setInfoEmpresa, setInfoGrupo, setProjeto } from '../../../layout/redux/layoutActions'
import SwotContent from './swotContent'
import { useEffect } from 'react'
import { filterHandle, listarSwots } from './redux/swotActions'
import Video from '../../videos/video'
import CriarDashboardButton from '../../dashboard/criardashboardbutton'
import { modalOpen } from '../../../layout/redux/layoutActions'
import Criar from '../../dashboard/criar'



export default () => {
  const dispatch = useDispatch()
  const { grupos, grupo, filters, empresas, empresa, sistema } = useSelector(state=> state.layoutState)
  const { projeto, filtersProvisorio, projetos, paginate, totalAvaliacao } = useSelector(state=> state.swotempresasState)

  const nls = require(`../swot/nls/${sistema.idioma}.json`)
  const nlsContexto = require(`../../centralAjuda/nlscontexto/${sistema.idioma}.json`)

  //USADO CASO O USUÁRIO DER REFRESH NA PÁGINA
  useEffect(() => {
  const wasRefreshed = sessionStorage.getItem('wasRefreshed')
  
  if (wasRefreshed === 'true' && projeto && projeto.id) {
    sessionStorage.removeItem('wasRefreshed')
    dispatch(setProjeto(projeto)) // ← Isso já dispara toda a cadeia!
  }

  const handleBeforeUnload = () => {
    sessionStorage.setItem('wasRefreshed', 'true')
  }
  
  window.addEventListener('beforeunload', handleBeforeUnload)
  return () => window.removeEventListener('beforeunload', handleBeforeUnload)
}, [projeto, dispatch])

  
  useEffect(()=> {
    if (projeto.id) {
        dispatch(filterHandle({projetoID: projeto.id, projeto, empresaId: empresa.empresaId, grupo, params: filters, filtersProvisorio, typeSelect: filters.typeSelect, paginate, idioma: sistema.idiomaIdValue, nls}))
    }
  }, [projeto, grupo, empresa, sistema.idiomaIdValue])

  const handleFormProjeto = (e) => {
    dispatch(setProjeto(e.value))
  }
  const handleGrupo = (e) => {
    dispatch(setInfoGrupo(e.value))
  }

  const handleFormFilterEmpresa = (e) => {
    dispatch(setInfoEmpresa(e.value))
  }

  const handleAbrirCriarDashboard = () => {
  dispatch(modalOpen('criar'))
}

  
  return (
    <div className='box-swot' data-cy='page-swotanalysis'>
      <div className='box-swot-topinfo'>
        <div>
          <div className='box-swot-topinfo-select'>
            <Select 
  name='projeto'
  cy='filter-project'
  label={nls.projeto}
              options={projetos}
              selected={projeto}
              action={(e)=> handleFormProjeto(e)}
              selectedItem={false}
              optionLabel='nomeProjeto'
              optionValue='id'
            />
          </div>
          <div className='box-swot-topinfo-select'>
            <Select 
  name='empresa'
  cy='filter-company'
  label={nls.empresaanalisada}
              options={empresas}
              selected={empresa}
              action={(e)=> handleFormFilterEmpresa(e)}
              selectedItem={false}
              optionLabel='descricaoEmpresa'
              optionValue='empresaId'
            />
          </div>

          {projeto?.temMenuEstabelecimento || projeto?.temMenuProduto
            ? (grupos && grupos.some(g => g?.name && g.name.trim() !== '')
              ? <div className='box-swot-topinfo-select'>
                  <Select 
  name='grupo'
  cy='filter-group'
  label={nls.grupo}
                    options={[{id: -1, name: nls.todosGrupos, [projeto?.temMenuProduto ? 'nomeGrupoProduto' : 'nomeGrupoEstabelecimento']: true }, ...grupos]}
                    selected={grupo}
                    action={(e)=> handleGrupo(e)}
                    selectedItem={false}
                  />
                </div>
              : null)
            : null}
            
        </div>
        <div className='box-swot-topinfo-avaliacao'>
            <label>{nls.numerodeavaliacoes}</label>
            <IcoStar />
            <strong data-cy='feedback-count'>{totalAvaliacao?totalAvaliacao:0}</strong>
        </div>
      </div>
      <Filter />

      <div className="box-comentarios-video">
        <Video videoName="video3" cy="tutorial" />

        {projeto?.tipoProjetoId &&
        projeto.tipoProjetoId !== 2 &&
        filters?.ciclo &&
        filters.ciclo.anoMesCiclo && (
            <CriarDashboardButton
  cy="dashboard-create-open"
  onClick={handleAbrirCriarDashboard}
/>
        )}

      </div>

      <SwotContent nlsContexto={nlsContexto} nls={nls} imprimir={totalAvaliacao > 0}/>

      <Criar />
      
    </div>
  )
}
